// star rating directive
//
//   <star-rating count="2.5" />

let module = angular.module('app.directives');

module.component('starRating', {
  restrict: 'E',
  bindings: {
    count: '=',
  },
  controllerAs: '$ctrl',
  template: `
    <span ng-switch="$ctrl.count">
      <span ng-switch-when="5">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
      </span>
      <span ng-switch-when="4.5">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star-half-o"></i>
      </span>
      <span ng-switch-when="4">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
      </span>
      <span ng-switch-when="3">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
      </span>
      <span ng-switch-when="2">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
      </span>
      <span ng-switch-when="1">
        <i class="fa fa-star"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
      </span>
      <span ng-switch-default>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
        <i class="fa fa-star-o" style="color:#ddd"></i>
      </span>
    </span>
  `,
});



// WEBPACK FOOTER //
// ./app/directives/star-rating.js